import api from "@/lib/api";

export const FARMANALIZA_URL = "https://www.farmanaliza.com/informacion";

export const trackFarmanaliza = (source) => {
  api.post("/farmanaliza/click", { source }).catch(() => {});
};
